module.exports = {
    login:{
        '1':'超进化物语后台管理',
        '2':'帐号',
        '3':'密码',
        '4':'登录',
        '5':'修改密码',
        '6':'修改成功',
    },
    master:{
        '1':'超进化物语后台管理',
        '2':'退出',
        '3':'世界服',
        '4':'游戏服',
        '5':'首页',
    },
    mask_word:{
    		'1':'屏蔽字',
    		'2':'输入屏蔽字',
    		'3':'搜索',
    		'4':'添加cjhwy2屏蔽字',
    		'5':'重载全部屏蔽字',
    		'6':'id',
    		'7':'屏蔽字',
    		'8':'操作',
    		'9':'来源',
    		'10':'强制检测屏蔽字OSS'
    	},
    activity_editor:{
        '6':'保底设置',
		'7':'天选之日',
		'8':'影响的服务器ids',
		'9':'活动名',
		'10':'描述',
		'11':'开关',
		'12':'开始日期',
		'13':'结束日期',
		'14':'活动总配置',
		'15':'活动详细配置',
		'16':'操作',
		'17':'编辑',
		'18':'删除',
		'19':'活动时间范围',
		'20':'至',
		'21':'开始日期',
		'22':'结束日期',
		'23':'参数配置',
		'24':'配方编号',
		'25':'请选择',
		'26':'造物台类型',
		'27':'X次内必得不朽或以上怪兽',
		'28':'触发 X次内必得不朽或以上怪兽 次数',
		'29':'消耗材料',
		'30':'消耗钻石',
		'31':'添加',
		'32':'修改',
		'33':'取消',
		'34':'通用配置',
		'35':'开启',
		'36':'关闭',
		'37':'添加天选之日',
		'38':'检测是否包含重复时间段',
	},
    config:{
		'1':'表名',
		'2':'请选择',
		'3':'查询表数据',
		'4':'查询更新时间',
		'5':'选择上传文件',
		'6':'批量上传',
		'7':'表名',
		'8':'更新时间',
		'9':'请选择表名!',
		'10':'上传成功',
		'11':'上传失败',
		'12':'请先上传文件',
        '13':'重载全部配置',
        '14':'服务器',
        '15':'IP地址',
        '16':'取消',
        '17':'确定重载',
        '18':'返回消息码',
        '19':'返回消息',
        '20':'重置单个配置',
        '21':'配置表版本',
	},
    dialog_editor:{
		'1':'上传乱入剧本',
		'2':'对话组编号',
		'3':'对话组',
		'4':'操作',
		'5':'显示对话组',
		'6':'对话模拟',
		'7':'下一句',
		'8':'关闭对话',
		'9':'格式错误！请重新选择!',
	},
    game_servers:{
		'1':'查询游戏服',
		'2':'创建游戏服',
		'3':'游戏服ID',
		'4':'游戏服名称',
		'5':'游戏服描述',
		'6':'游戏服主IP',
		'7':'游戏服副IP',
		'8':'操作',
		'9':'编辑',
		'10':'合服',
		'11':'添加副IP',
		'12':'取消',
		'13':'确定',
		'14':'游戏服IP',
		'15':'编辑游戏服',
		'16':'合服',
		'17':'创建成功',
		'18':'删除成功',
		'19':'更新成功',
		'20':'合服成功',
		'21':'此操作将删除该服务器信息, 是否继续?',
		'22':'游戏服',
		'23':'世界服',
	},
    lang_conf:{
		'1':'请输入i18n关键字/中文/英文/日文/韩文',
		'2':'搜索',
		'3':'i18n关键字',
		'4':'中文',
		'5':'英文',
		'6':'日文',
		'7':'韩文',
		'8':'修改',
		'9':'修改语义!',
		'10':'取消',
		'11':'修改',
		'12':'操作成功',
        '13':'同步配置',
        '14':'导出json',
		'15':'本版号',
		'16':'语言',
		'17':'本版描述',
		'18':'最后一次更改日期',
		'19':'操作',
		'20':'审核用',
		'21':'导出语言包',
		'22':'id',
		'23':'语言包版本'
	},
    level_editor:{
		'1':'请选择',
		'2':'添加',
		'3':'百分比填小数',
		'4':'怪兽',
		'5':'编号',
		'6':'性格',
		'7':'等级',
		'8':'基因强化条数',
		'9':'基因编号',
		'10':'技能等级',
		'11':'极化攻击力',
		'12':'极化体力',
		'13':'极化霸气',
		'14':'极化移动速度',
		'15':'极化能力条数',
		'16':'元核',
		'17':'效果',
		'18':'等级',
		'19':'进阶次数',
		'20':'词条属性条数',
		'21':'效果',
		'22':'浮动值',
		'23':'宿命',
		'24':'效果',
		'25':'浮动值',
		'26':'同调效果',
		'27':'其他增减益条数',
		'28':'确认',
		'29':'取消',
		'30':'神灵',
		'31':'编号',
		'32':'等级',
		'33':'神灵契约',
		'34':'层数',
		'35':'层等级',
		'36':'神灵自动释放序列',
		'37':'条数',
		'38':'释放次数',
		'39':'起源基石增益',
		'40':'条数',
		'41':'增益提升',
		'42':'黑暗森林增益',
		'43':'条数',
		'44':'等级',
		'45':'皮肤增益',
		'46':'战墙',
		'47':'加固次数',
		'48':'战纹效果条数',
		'49':'配置',
		'50':'生成',
		'51':'解析',
		'52':'等级',
		'53':'白',
		'54':'绿',
		'55':'蓝',
		'56':'紫',
		'57':'橙',
		'58':'红',
		'59':'1次',
		'60':'2次',
		'61':'3次',
		'62':'循环',
		'63':'攻击力',
		'64':'体力',
		'65':'霸气',
		'66':'移动速度',
		'67':'真实伤害',
		'68':'生物屏障',
		'69':'攻击速度',
		'70':'射程',
		'71':'子弹速度',
		'72':'体型',
		'73':'普攻回复',
		'74':'自愈回复',
		'75':'增益效果持续时间',
		'76':'负面效果持续时间',
		'77':'回复效果',
		'78':'攻击力%',
		'79':'体力%',
		'80':'霸气%',
		'81':'移动速度%',
		'82':'真实伤害%',
		'83':'生物屏障%',
		'84':'攻击速度%',
		'85':'射程%',
		'86':'子弹速度%',
		'87':'体型%',
		'88':'普攻回复%',
		'89':'愈回复%',
		'90':'增益效果持续时间%',
		'91':'负面效果持续时间%',
		'92':'回复效果%',
		'93':'被击退时忽视敌方霸气',
	},
    reward_editor:{
		'1':'大类',
		'2':'请选择',
		'3':'编号',
		'4':'碎片',
		'5':'主属性',
		'6':'品质',
		'7':'等级',
		'8':'选择元核等级',
		'9':'阶段',
		'10':'选择元核阶段',
		'11':'宿命',
		'12':'关闭随机',
		'13':'开启随机',
		'14':'词条',
		'15':'添加词条',
		'16':'删除词条',
		'17':'觉醒结晶',
		'18':'觉醒结晶碎片',
		'19':'数量',
		'20':'开启随机数量',
		'21':'关闭随机数量',
		'22':'数量1',
		'23':'数量2',
		'24':'爆率',
		'25':'开启爆率',
		'26':'关闭爆率',
		'27':'数量设置(小于1的小数)',
		'28':'添加奖励',
		'29':'整理标签',
		'30':'最终解析串',
		'31':'白',
		'32':'绿',
		'33':'蓝',
		'34':'紫',
		'35':'橙',
		'36':'红',
		'37':'二字词条',
		'38':'四字词条',
		'39':'必要资源',
		'40':'怪兽',
		'41':'怪兽碎片',
		'42':'材料/道具',
		'43':'元核',
		'44':'觉醒结晶',
		'45':'战纹',
		'46':'觉醒结晶碎片',
		'47':'部落公共资源',
        '48':'按配置随机属性',
        '49':'',
        '50':'必出指定属性',
        '51':'必定不出',
        '52':'特殊',
        '53':'自定义概率'
	},
    plate:{
        '1':'重量',
        '2':'技能数量',
		'3':'当前起源盘的品质权重'
    },
    world_servers:{
		'1' :'查询世界区',
		'2' :'创建世界区',
		'3' :'世界区ID',
		'4' :'世界区名称',
		'5' :'世界区描述',
		'6' :'世界区主IP',
		'7' :'世界区副IP',
		'8' :'操作',
		'9' :'编辑',
		'10':'合服',
		'11':'添加副IP',
		'12':'取消',
		'13':'确定',
		'14':'世界区主IP',
		'15':'编辑世界区',
		'16':'合区',
		'17':'创建成功',
		'18':'删除成功',
		'19':'更新成功',
		'20':'合服成功',
		'21':'此操作将删除该服务器信息, 是否继续?',
		'22':'游戏服',
		'23':'世界服',
	},

    post_mails:{},
    query_players:{},

    menu: {
        "1000": "内部工具",
        "1001": "管理员",
        "1002": "权限管理",
        "1003": "操作日志查询",
        "1004": "服务器-游戏服",
        "1005": "服务器-世界区",
        "2000": "策划工具",
        "2001": "配置管理",
        "2002": "关卡编辑器",
        "2003": "奖励串编辑器",
        "2004": "活动编辑器",
        "2005": "对话编辑器",
        "2006": "屏蔽字编辑",
        "2007": "礼包兑换码",
        "3000": "运营工具",
        "3001": "语义化管理",
        "3002": "充值统计",
        "3003": "运营统计",
		"3004": "封号禁言",
        "3005": "GM公告",
        "4000": "邮件工具",
        "4001": "邮件模板",
        "4002": "普通邮件",
        "4003": "全局邮件",
        "5000": "玩家相关",
        "5001": "玩家查询",
        "5002": "聊天留言查询",
        "5003": "玩家邮件查询",
        "5004": "玩家充值查询",
        "5005": "礼包查询及补偿",
        "6000": "测试工具",
        "6001": "常用工具",
        "6002": "模拟充值",


    },
    servers: {
        '1' :'查询世界区',
        '2' :'查询游戏服',
        '3' :'创建世界区',
        '4' :'创建游戏服',
        '5' :'游戏服ID',
        '6' :'游戏服名称',
        '7' :'游戏服描述',
        '8' :'游戏服主IP',
        '9' :'游戏服副IP',
        '10':'操作',
        '11':'编辑',
        '12':'合服',
        '13':'取消关联',
        '14':'上传ips',
        '15':'上传connect',
        '16':'下载',
        '17':'世界区ID',
        '18':'世界区名称',
        '19':'世界区描述',
        '20':'世界区主IP',
        '21':'世界区副IP',
        '22':'关联的世界区',
        '23':'名称',
        '24':'描述',
        '25':'ID',
        '26':'主IP',
        '27':'添加副IP',
        '28':'副IP',
        '29':'取消',
        '30':'确定',
        '31':'编辑游戏服',
        '32':'编辑世界区',
        '33':'合区',
        '34':'关联游戏服',
        '35':'创建成功',
        '36':'更新成功',
        '37':'合服成功',
        '38':'添加关联游戏服',
        '39':'关联成功',
        '40':'取消关联成功',
        '41':'上传成功',
        '42':'登录服配置',
        '43':'全服跨服配置',
        '44':'通信服IP',
    }
}



// WEBPACK FOOTER //
// ./src/lang/i18nCN.js